/**
 * A function that does nothing.
 * @param args
 * @returns {void}
 */
const noop = (...args) => {}; // eslint-disable-line no-unused-vars

export default noop;
